<script setup lang="ts">
import {
  CommandModal,
  ConfirmModal,
  ErrorModal,
  TextPromptModalStore,
} from '@nora-monorepo/ui-shared';

import { DefaultCommandsPlugin } from '#nora-ui/components/modals/command-modal/plugins/default-commands-plugin';
import ConsentModal from '#nora-ui/components/modals/consent-modal/ConsentModal.vue';
import GeofenceModal from '#nora-ui/components/modals/geofence-modal/GeofenceModal.vue';
import OperationChatModal from '#nora-ui/components/modals/operation-chat-modal/OperationChatModal.vue';
</script>

<template>
  <ConsentModal />
  <GeofenceModal />
  <OperationChatModal />
  <CommandModal
    modal-id="noraCommandModal"
    :plugins="[
      DefaultCommandsPlugin(),
    ]"
  />
  <ConfirmModal />
  <TextPromptModalStore />
  <ErrorModal />
</template>
